// One row per store attached to this event. Vendors whose response has no stores
// (or none for this event) still get a single row so they don't disappear.
export const toRosterRows = (vendors, eventId) =>
    vendors.flatMap((vendor) => {
        const stores = (vendor?.stores || (vendor?.store ? [vendor.store] : [])).filter(
            (store) => !store?.event_id || String(store.event_id) === String(eventId)
        );
        if (!stores.length) return [{ key: vendor?.id || vendor?.email, vendor, store: null }];
        return stores.map((store) => ({ key: `${vendor?.id}-${store?.id}`, vendor, store }));
    });
